import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | guest

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setStatus("guest");
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setTenant(data.tenant);
        setStatus("authed");
      })
      .catch(() => {
        localStorage.removeItem("token");
        setStatus("guest");
      });
  }, []);

  const login = (token, userData, tenantData) => {
    localStorage.setItem("token", token);
    setUser(userData);
    setTenant(tenantData);
    setStatus("authed");
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setTenant(null);
    setStatus("guest");
  };

  return (
    <AuthContext.Provider value={{ user, tenant, status, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
